import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import AISendButton from "./AISendButton";

export default function AIChatInput({ value, onChange, onSend, disabled, sending }) {
  const canSend = Boolean(String(value || "").trim()) && !disabled && !sending;

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      if (canSend) onSend();
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-end",
        gap: 1,
        px: 2,
        pt: 1.25,
        pb: 1.5,
        borderTop: "1px solid rgba(148,163,184,0.25)",
        bgcolor: "#ffffff",
      }}
    >
      <TextField
        fullWidth
        multiline
        maxRows={5}
        minRows={1}
        placeholder="Ask Microlab AI… (Enter to send, Shift+Enter for new line)"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={disabled || sending}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: 2.5,
            bgcolor: "#f8fafc",
            fontSize: 14,
            alignItems: "flex-end",
          },
        }}
      />
      <AISendButton disabled={!canSend} loading={sending} onClick={onSend} />
    </Box>
  );
}

AIChatInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSend: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  sending: PropTypes.bool,
};
